import { HeaderBarBannerData } from '../../../common/apiAdapters/types';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import {
    Banners,
    SHOW_BANNER,
    HIDE_BANNER,
    SET_BANNER_DATA,
    SetBannerDataAction,
    ShowBannerAction,
    HideBannerAction,
    FetchBannerDataAction,
    FETCH_BANNER_DATA,
} from './types';

export const showBanner = (id: Banners): ShowBannerAction => ({
    type: SHOW_BANNER,
    identifier: id,
});

export const hideBanner = (id: Banners): HideBannerAction => ({
    type: HIDE_BANNER,
    identifier: id,
});

export const setBannerData = (id: Banners, data: HeaderBarBannerData): SetBannerDataAction => ({
    type: SET_BANNER_DATA,
    payload: data,
    identifier: id,
});

export const isFetchingHeaderBarBannerAction = (identifier: string): FetchBannerDataAction => ({
    type: FETCH_BANNER_DATA,
    identifier,
});

export const fetchHeaderBarBannerAction = (): DataFetchingThunkAction => async (
    dispatch,
    _,
    { apiService, logger }
) => {
    const identifier = Banners.HEADER_BAR_BANNER;
    dispatch(isFetchingHeaderBarBannerAction(identifier));
    try {
        const headerBarBannerData = await apiService.shopApi.getHeaderBarBannerData();
        if (headerBarBannerData && headerBarBannerData.data) {
            dispatch(setBannerData(identifier, headerBarBannerData.data));
        }
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchHeaderBarBanner');
    }
};
